import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { Button } from '@famly/mf_input_button';
import { createStack } from '@famly/mf_layout_stack';
import translate from 'signin-app/helpers/translate';
import { useScrollXPosition } from '@famly/stat_ts-utils_observable-hooks';
export const Wrapper = styled(createStack({})) `
    width: 100%;
    flex: 1;
`;
export const CarouselContainer = styled.div `
    width: 100%;
    display: flex;
    scroll-snap-type: x mandatory;
    overflow-x: auto;
    &::-webkit-scrollbar {
        background: transparent;
    }
`;
export const CarouselSlot = styled.div `
    flex: 1 0 100%;
    scroll-snap-align: center;
`;
const SlideButtonContainer = styled(createStack({
    width: '100%',
    justifyContent: 'space-between',
    position: 'fixed',
    bottom: '0',
    left: '0',
    px: '40px',
    boxSizing: 'border-box',
    pb: '26px',
})) ``;
const NEXT = 'NEXT';
const PREV = 'PREV';
export const SwipeableView = (props) => {
    const containerRef = React.useRef(null);
    const count = React.Children.count(props.children);
    const scrollPosition = useScrollXPosition({
        target: containerRef,
        debounce: 50,
    });
    const { isNextButtonDisabled, isPrevButtonDisabled } = React.useMemo(() => {
        if (count <= 1) {
            return {
                isNextButtonDisabled: true,
                isPrevButtonDisabled: true,
            };
        }
        if (!containerRef.current) {
            return {
                isNextButtonDisabled: count <= 1,
                isPrevButtonDisabled: true,
            };
        }
        const { scrollWidth, clientWidth } = containerRef.current;
        return {
            isNextButtonDisabled: scrollPosition === scrollWidth - clientWidth,
            isPrevButtonDisabled: scrollPosition === 0,
        };
    }, [count, scrollPosition]);
    const slide = (dir) => {
        if (!containerRef.current) {
            return;
        }
        const containerEl = containerRef.current;
        const containerWidth = containerEl.clientWidth;
        if (dir === PREV) {
            containerEl.scrollBy({
                left: -containerWidth,
                behavior: 'smooth',
            });
        }
        if (dir === NEXT) {
            containerEl.scrollBy({
                left: containerWidth,
                behavior: 'smooth',
            });
        }
    };
    return (_jsxs(Wrapper, { children: [_jsx(CarouselContainer, { ref: containerRef, children: React.Children.map(props.children, child => (_jsx(CarouselSlot, { children: child }))) }), _jsxs(SlideButtonContainer, { children: [!isPrevButtonDisabled && (_jsx(Button, { onClick: () => slide(PREV), text: translate('prev'), variant: "secondary", icon: "arrow_back" })), !isNextButtonDisabled && (_jsx(Button, { ml: "auto", onClick: () => slide(NEXT), text: translate('next'), variant: "secondary", icon: "arrow_forward" }))] })] }));
};
